import { useParams } from "react-router-dom"
import ReasignarInstlacionAgendaCorporativa from "../../shared/components/reasignar_agenda_corporativa/SaveReasignarInstlacionAgendaCorp"
import { useGetAgendaCorporativaById } from "@/shared/actions/erp/agendamiento_corporativo"
import { LoaderComponent } from "@/shared/components/ui"

export default function ReasignarInstlacionAgendaCorporativaPage() {

  const { idagenda } = useParams()

  const { data, isLoading } = useGetAgendaCorporativaById(idagenda!)

  if (isLoading) return <LoaderComponent />

  if (data == null)
    return <>{"NO EXISTE AGENDAMIENTO [404]"}</>;

  return (
    <ReasignarInstlacionAgendaCorporativa
      title="Reasignar Agendado Corporativo"
      agendamiento={data?.data}
    />
  )

}